import React, { useCallback } from 'react';

import { Box, Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import useEffectOnce from 'hooks/use-effect-once';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';

const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${Styles.color.grey.five};
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

// These styles are taken from the `cart-error` component,
// they should be extracted into a common component
const Header = styled.h2`
  font-family: ${Styles.fontFamily.base};
  letter-spacing: -0.42px;
  line-height: 1.1;
  text-transform: uppercase;
  text-align: center;
  max-width: 75%;

  ${Styles.mobileLandscape`
    font-size: 2rem;
    margin: 1.25rem 0;
  `}

  ${Styles.desktop`
    max-width: 500px;
  `}

  ${Styles.kiosk`
    color: ${Styles.color.black};
  `}
`;

const Subheading = styled.h3`
  color: ${Styles.color.black};
  font-size: 0.9375rem;
  font-weight: 400;
  text-align: center;
`;

function ErrorNetwork() {
  const mParticle = useMParticleContext();
  const { formatMessage } = useIntl();
  const localeTitle = formatMessage({ id: 'lostNetworkConnectivity' });
  const localeBody = formatMessage({ id: 'checkNetworkSettings' });

  const onReload = useCallback(() => {
    if (window && window.location) {
      mParticle.logEvent(CustomEventNames.NETWORK_ERROR_RELOAD, EventTypes.Other);
      window.location.reload();
    }
  }, [mParticle]);

  useEffectOnce(() => {
    mParticle.logEvent(CustomEventNames.NETWORK_ERROR, EventTypes.Other);
  });

  return (
    <Container data-testid="error-network">
      <Inner>
        <Icon icon="error" color="primary" width="150px" height="150px" />
        <Header>{localeTitle}</Header>
        <Subheading>{localeBody}</Subheading>

        <Box margin="1rem" minWidth="auto" width="100%">
          <ActionButton
            onlyIcon
            fullWidth
            onClick={onReload}
            data-testid="error-network-reload-btn"
          >
            {formatMessage({ id: 'reload' })}
          </ActionButton>
        </Box>
      </Inner>
    </Container>
  );
}

export default ErrorNetwork;
